export default "__VITE_ASSET__8718f7c2__"